/**
 * Logo.tsx — OptiYield brand mark.
 *
 * Renders the official logo from src/assets:
 *   - variant="full" (default): the full wordmark with pill border (OptiYield_logo.png,
 *     transparent background — works on light headers).
 *   - variant="dark": the dark-background version (OptiYield_logo_dark.png — for dark headers).
 *   - variant="icon": the background-less icon mark (OptiYield_icon_nobg.svg, ~1:1)
 *     for mobile/collapsed headers; the favicon uses it too.
 *
 * Props:
 *   variant   — 'full' | 'dark' | 'icon'. Default 'full'.
 *   className — forwarded for size/spacing overrides (height controls scale; w-auto keeps aspect).
 */
import { cn } from '@/lib/utils'
import fullLogo from '@/assets/OptiYield_logo.png'
import darkLogo from '@/assets/OptiYield_logo_dark.png'
import iconMark from '@/assets/OptiYield_icon_nobg.svg'

interface LogoProps {
  className?: string
  variant?: 'full' | 'dark' | 'icon'
}

export function Logo({ className, variant = 'full' }: LogoProps) {
  const src = variant === 'icon' ? iconMark : variant === 'dark' ? darkLogo : fullLogo
  return <img src={src} alt="OptiYield" className={cn('h-8 w-auto', className)} />
}
